import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBar } from 'app/shared/progress-bar/progress-bar';
import { PcLoadingBarComponent } from 'app/shared/components/loading-bar/loading-bar.component';

@NgModule({
  declarations: [PcLoadingBarComponent],
  imports: [CommonModule, ProgressBar],
  exports: [PcLoadingBarComponent],
})
export class PcLoadingBarModule {}
